import React from "react";

const Pagination = ({ page, limit, totalCount, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil((totalCount || 0) / (limit || 1)));
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  if (totalPages <= maxVisible) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else if (page <= 3) {
    pages.push(1, 2, 3, 4, "...", totalPages);
  } else if (page >= totalPages - 2) {
    pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
  }

  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, totalCount);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-6 pt-4 border-t border-ink-100">
      <p className="text-sm text-ink-500">
        Showing {startItem}–{endItem} of {totalCount}
      </p>
      <div className="flex items-center gap-1.5">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="px-3 py-1.5 rounded-lg text-sm font-semibold border border-ink-200 text-ink-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-ink-50"
        >
          Prev
        </button>
        {pages.map((p, idx) =>
          p === "..." ? (
            <span key={`dots-${idx}`} className="px-2 text-ink-400">
              …
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${
                p === page
                  ? "bg-brand-600 text-white"
                  : "border border-ink-200 text-ink-700 hover:bg-ink-50"
              }`}
            >
              {p}
            </button>
          )
        )}
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="px-3 py-1.5 rounded-lg text-sm font-semibold border border-ink-200 text-ink-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-ink-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
